<template>
  <div>
    <input type="file" name="files" @change="fileUpload" id="files" ref="fileUpload" multiple="multiple" />
    <small class="text-danger" v-show="errors.has('files')">
      {{ getError('files') }}
    </small>
    <div v-if="hasExistingFiles" style="margin-top: 20px;">
      <h6>File(s) Exist - Check to Overwrite Existing</h6>
      <ul style="padding-left: 0; list-style: none; margin: 12px 0 2px 0;">
        <li v-for="(existingFile, index) in existingFiles">
          <el-checkbox v-model="overwriteExisting[index]">{{ existingFile }}</el-checkbox>
        </li>
      </ul>
      <strong>Note:</strong> Existing files will not be overwritten unless the checkbox next to each file is selected.
    </div>
    <div class="upload-progress" v-if="isSaving">
      <p-progress :value="uploadProgress" type="info"></p-progress>
    </div>

    <button @click="validateAndSubmit" class="btn btn-fill btn-info btn-wd btn-save pull-right" :disabled="isSaving || isInitial">Upload Form(s)</button>
    <div style="clear:both"></div>
  </div>
</template>

<script>
  import {notifySuccess, notifyError} from 'src/utilities/utils'
  import {mapGetters} from 'vuex'
  import Constants from 'src/utilities/constants'
  import PProgress from 'src/components/UIComponents/Progress.vue'
  import {OK, UNAUTHORIZED} from 'http-status-codes'

  const STATUS_INITIAL = 0
  const STATUS_SAVING = 1
  const STATUS_SUCCESS = 2
  const STATUS_FAILED = 3
  const STATUS_READY_FOR_UPLOAD = 5

  export default {
    props: ['data'],
    components: {
      PProgress
    },
    computed: {
      ...mapGetters({
        uploadProgress: 'files/uploadProgress'
      }),
      isInitial () {
        return this.currentStatus === STATUS_INITIAL
      },
      isSaving() {
        return this.currentStatus === STATUS_SAVING
      },
      hasExistingFiles() {
        return this.existingFiles.length > 0
      }
    },
    data() {
      return {
        overwrite: false,
        formName: null,
        currentStatus: null,
        existingFiles: [],
        overwriteExisting: [],
        modelValidations: {
          fileUpload: { // TODO get validation working on file upload
            required: true
          }
        }
      }
    },
    methods: {
      async fileUpload(event) {
        this.existingFiles = []
        if (event.target.files.length > 0) {
          this.currentStatus = STATUS_READY_FOR_UPLOAD

          const filesInput = document.querySelector('#files')
          const files = filesInput.files

          let folder = Constants.FOLDERS.INSPECTION_FORMS
          if (Constants.FOLDERS.FLOOR_PLANS === this.data.folder) {
            folder = Constants.FOLDERS.FLOOR_PLANS
          } else if (Constants.FOLDERS.ENERGY_PLANS === this.data.folder) {
            folder = Constants.FOLDERS.ENERGY_PLANS
          }

          const filesToValidate = []

          for (let file of files) {
            filesToValidate.push({ name: file.name, path: folder });
          }

          const response = await this.$store.dispatch('files/validateInUse', filesToValidate)

          if (OK === response.status) {
            if (response.data.length > 0) {
              response.data.forEach(file => {
                this.existingFiles.push(file.name)
              })
            }
          }
        }
      },
      async validateAndSubmit() {
        this.currentStatus = STATUS_SAVING
        const filesInput = document.querySelector('#files')

        if (await this.$validator.validateAll()) {
          const payload = {
            path: this.data.folder,
            files: filesInput.files
          }

          const overwriteFiles = []
          for (let i = 0; i < this.existingFiles.length; i++) {
            if (this.overwriteExisting[i]) {
              overwriteFiles.push(this.existingFiles[i])
            }
          }

          payload.overwrite = overwriteFiles

          const response = await this.$store.dispatch('files/uploadFiles', payload)

          if (OK === response.status) {
            notifySuccess(this, 'File(s) Uploaded Successfully')
            this.currentStatus = STATUS_SUCCESS

            switch (this.data.folder) {
              case Constants.FOLDERS.INSPECTION_FORMS:
                this.$eventHub.$emit('inspectionFormUploaded', response.data)
                break
              case Constants.FOLDERS.FLOOR_PLANS:
                this.$eventHub.$emit('floorPlanUploaded', response.data)
              case Constants.FOLDERS.ENERGY_PLANS:
                this.$eventHub.$emit('energyPlanUploaded', response.data)
            }

            this.$emit('close')
          } else if (UNAUTHORIZED === response.status) {
            notifyError(this, 'File uploading is not permitted for your user account.')
          this.currentStatus = STATUS_FAILED
          } else {
            notifyError(this, 'Failed to Upload Form(s)')
          this.currentStatus = STATUS_FAILED
          }
        }
      },
      getError(fieldName) {
        return this.errors.first(fieldName)
      }
    },
    mounted() {
      this.currentStatus = STATUS_INITIAL
      this.overwrite = false
    },
    destroyed() {
      this.currentStatus = STATUS_INITIAL
      this.overwrite = false
    }
  }
</script>

<style scoped>
  .upload-progress {
    margin-top: 15px;
  }
</style>
